import Joi from "joi";

const BedNumberSchema = Joi.object({
  bedSubCategory: Joi.string().trim().required().messages({
    "string.empty": "Sub Category is required.",
  }),
  bedNumber: Joi.string().trim().required().messages({
    "string.empty": "Bed Number is required.",
  }),
  cost: Joi.number().min(0).optional().messages({
    "number.base": "Cost must be a number.",
    "number.min": "Cost cannot be negative.",
  }),
}).unknown(true);

export default BedNumberSchema;
